
<div *ngIf="imgList.length > 0" class="showcase">
  <img src="{{imageUrl(imgList[selectedIndex])}}" alt="">
  <div class="overlay" [class.isChanging]="isChanging">
    <div class="left" (click)="previous()">
      <mat-icon class="material-icons-outlined" [ngStyle]="{ width: '36px', height: '36px', 'font-size': '36px' }">arrow_left</mat-icon>
    </div>
    <div class="right" (click)="next()">
      <mat-icon class="material-icons-outlined" [ngStyle]="{ width: '36px', height: '36px', 'font-size': '36px' }">arrow_right</mat-icon>
    </div>
  </div>
</div>
<div class="images">
  <h4 class="title">Képek:</h4>
  <div class="image-container">
    <div class="image-content" *ngFor="let item of imgList; let i = index;" [ngStyle]="{ border: i === selectedIndex ? '2px solid #297535' : '2px solid black' }">
      <img src="{{imageUrl(item)}}" />
      <div class="button">
        <app-button (click)="delImg(item)" [icon]="'delete'" [fontSize]="14" [customColor]="'red'"></app-button>
      </div>
      <div *ngIf="!isSelectedToDownload(item)" class="download">
        <app-button (click)="selectToDownload(item)" [icon]="'add'" [fontSize]="14"></app-button>
      </div>
      <div *ngIf="isSelectedToDownload(item)" class="download">
        <app-button (click)="selectToDownload(item)" [icon]="'done'" [fontSize]="14" [customColor]="'green'"></app-button>
      </div>
      <div class="overlay" (click)="select(item)"></div>
    </div>
  </div>
  <app-upload-ticket-file 
    fileType="image"
    [ticket]="instance"
    [refresh]="refresh"
  ></app-upload-ticket-file>
  <app-button *ngIf="selectedToDownload.length !== 0" (click)="downloadAll(selectedToDownload)" [title]="downloadTitle()"></app-button>
</div>
